import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function notificationList(data) {
    const options = {
        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios
        .post(`${url}/notifications/list`, data, options)
        .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
                let errorInfo = '';
                for (const [key, value] of Object.entries(res.data)) {
                    errorInfo += `<br> ${key}: ${value} <br>`;
                }
                errorInfo += `<br> API LINK: ${url}notifications/list <br>`;
                throw new Error(errorInfo);
            }
            return res.data;
        })
        .catch((err) => {
            throw new Error(err.stack);
        });
}

function notificationDetails(data) {
    const options = {
        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios
        .post(`${url}/notifications/details`, data, options)
        .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
                let errorInfo = '';
                for (const [key, value] of Object.entries(res.data)) {
                    errorInfo += `<br> ${key}: ${value} <br>`;
                }
                errorInfo += `<br> API LINK: ${url}notifications/details <br>`;
                throw new Error(errorInfo);
            }
            return res.data;
        })
        .catch((err) => {
            throw new Error(err.stack);
        });
}

function trackView(data) {
    const options = {
        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios
        .post(`${url}/notifications/track-view`, data, options)
        .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
                let errorInfo = '';
                for (const [key, value] of Object.entries(res.data)) {
                    errorInfo += `<br> ${key}: ${value} <br>`;
                }
                errorInfo += `<br> API LINK: ${url}notifications/track-view <br>`;
                throw new Error(errorInfo);
            }
            return res.data;
        })
        .catch((err) => {
            throw new Error(err.stack);
        });
}

export default {
    notificationList,
    notificationDetails,
    trackView,
};
